import WithRoleAuthorization, { Role, listOfRoles } from 'components/WithRoleAuthorization/WithRoleAuthorization'
import React from 'react'
import { ArchiveButton, ForwardButton } from '../../styles'
import { notificationStatus } from 'constants/notificationStatus'
import { MdOutlineInventory2 } from 'react-icons/md'
import { UserDataType } from 'types/autentication'


export interface IArchiveTreatment {
  currentUser: UserDataType
  handleArchiveNotification: () => void
  archiveIconStyle: string
  notificationStatusState: string
  loggedInUserIsResponsible: boolean
  currentStepSelected: number
  isDirtyStyle: "" | "border-mediumGray text-mediumGray"
  isDirty: boolean
}
export const archiveAllowedUsers = [listOfRoles.admin, listOfRoles.location_qa,listOfRoles.corporate_quality_board]
export default function ArchiveTreatment({ archiveIconStyle,
  isDirty, isDirtyStyle, currentStepSelected, currentUser, handleArchiveNotification,
  notificationStatusState, loggedInUserIsResponsible }: IArchiveTreatment) {
  const shouldRender = notificationStatusState !==
    notificationStatus[5].label && notificationStatusState !==
    notificationStatus[4].label
  if (!shouldRender) {
    return null
  }
  return (
    <WithRoleAuthorization
      allowedRoles={archiveAllowedUsers}
      userRole={currentUser?.profile}
      children={
        <ArchiveButton
          data-testid="test-archive-button"
          className={isDirtyStyle}
          disabled={!!isDirty}
          type="button"
          onClick={handleArchiveNotification}
        >
          <MdOutlineInventory2
            className={archiveIconStyle}
          />
          Arquivar notificação
        </ArchiveButton>
      }
    />
  )
}
